module.exports = __webpack_public_path__ + "static/img/client_new_cn1.799947e2.png";